import { render, staticRenderFns } from "./sk-radio-img-wap.vue?vue&type=template&id=a08ffe4a&scoped=true&"
import script from "./sk-radio-img-wap.vue?vue&type=script&lang=js&"
export * from "./sk-radio-img-wap.vue?vue&type=script&lang=js&"
import style0 from "./sk-radio-img-wap.vue?vue&type=style&index=0&id=a08ffe4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08ffe4a",
  null
  
)

export default component.exports